import { useEffect } from 'react';
import StandardButton from './StandardButton';
import { Grid, Button } from '@mui/material';

const SubBullet = (props) => {
    if (props.bullet === "Position:" || props.bullet === "Positions:") {
        return (
            <>
                <li key={props.index} dangerouslySetInnerHTML={{ __html: `${props.bullet}` }}></li>
                <ul>
                    {props.subbullets.map((sb, i) => 
                        <li key={i} dangerouslySetInnerHTML={{ __html: `${sb}` }}></li>
                    )}
                </ul>
            </>
        )
    } else {
        return <li key={props.index} dangerouslySetInnerHTML={{ __html: `${props.bullet}` }}></li>
    }
};

const DataDisplay = ({hotspotData, keyId, ...props}) => {
    const handleDrift = () => {
       // alert(1);
        window.drift.api.startInteraction({ interactionId: 322946 });
     
    };

   

    return (
        <div className="display-column fade-in">
            { hotspotData.paragraphs &&           
                <div className="info-in-col">
                    { hotspotData.image && 
                        <div className="img-in-col">
                            <img src={hotspotData.image} alt={hotspotData.title} />
                        </div>
                    }

                    { hotspotData.title && 
                        <h3 className="title-in-col">{hotspotData.title}</h3>
                    }

                    { hotspotData.paragraphs.map((p, index) => {
                        var texts = p.pain.text;
                        var bullets = p.solution.list;
                        var subBullets = p.solution.sublist;

                        return (
                            <div key={index} className="paragraph-in-col">
                                <h4>{p.pain.subtitle}:</h4>
                                { texts && texts.length > 0 ? 
                                    texts.map((t, index) => <p key={index}>{t}</p>)
                                :
                                    <p>{p.pain.text}</p>
                                }

                                <h4>{p.solution.subtitle}:</h4>
                                <ul style={{ paddingInlineStart: '27px' }}>
                                    { bullets && bullets.length > 0 ?
                                        subBullets.length > 0 ?
                                            bullets.map((b, index) => {
                                                return <SubBullet key={index} bullet={b} subbullets={subBullets} index={index} />
                                            })
                                        :
                                            bullets.map((b, index) => {
                                                return <li key={index} dangerouslySetInnerHTML={{ __html: `${b}` }}></li>
                                            })
                                    :
                                        <li key={index}>{p.solution.list}</li>
                                    }
                                </ul>
                            </div>
                        )
                    }) }
                </div>
            }

            { hotspotData.link && 
                <Grid container className="btn-in-col">
                    <Grid item xs={12} sm={6}>
                        <Button className="cta-btn cta--primary talkToAnExpert cta--internal drift-open-chat" onClick={() => handleDrift()}>talk to an expert <i className="cta-icon"></i></Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <StandardButton location={hotspotData.link} btnclass="cta-btn cta--secondary cta--internal learnMore">learn more</StandardButton>                        
                    </Grid>
                </Grid>
            }

        </div>
    );
}

export default DataDisplay;